export const Constants = {
  STATUS: [
    {value: 'PENDING_RECEPTION', text: 'Pendiente de recepción'},
    {value: 'PENDING_CUSTOMER_COLLECT', text: 'Pendiente de recojo cliente'},
    {value: 'PENDING_DISPATCH', text: 'Pendiente de despacho'},
    {value: 'PARTIALLY_DELIVERED', text: 'Entregado parcialmente'},
    {value: 'DELIVERED', text: 'Entregado'},
    {value: 'CANCELLED', text: 'Cancelado'},
    {value: 'RETURNED', text: 'En devolución'},
    {value: 'RETURNED_SELLER', text: 'Devuelto a seller'},
    {value: 'RETURNED_ORIGIN', text: 'Devuelto a origen'}
  ],
  DISPATCH_STATUS: [
    { value: 'WORKING', text: 'En trabajo' },
    { value: 'PAYMENT_PENDING', text: 'Pago pendiente' },
    { value: 'PAYMENT_ONLINE', text: 'Pago online' },
    { value: 'PAYED', text: 'Pagada' },
    { value: 'PARTIALLY_DELIVERED', text: 'Parcialmente entregada' },
    { value: 'DELIVERED', text: 'Entregada' },
    { value: 'CANCELLED', text: 'Cancelada' },
    { value: 'CANCELLED_NOT_PAYED', text: 'Cancelada no pagada' },
  ],
  MESSAGE_STATE_PAY: {
    PAID: 'La nota de venta aún no ha sido pagada',
    getProps: () => [
      {value: 'PAID', text: 'La nota de venta aún no ha sido pagada'}
    ]
  },
  LIST_DISPATCH_STATUS: {
    WORKING: { value: 'WORKING', text: 'En trabajo' },
    PAYMENT_PENDING: { value: 'PAYMENT_PENDING', text: 'Pago pendiente' },
    PAYMENT_ONLINE: { value: 'PAYMENT_ONLINE', text: 'Pago online' },
    PAYED: { value: 'PAYED', text: 'Pagada' },
    PARTIALLY_DELIVERED: { value: 'PARTIALLY_DELIVERED', text: 'Parcialmente entregada' },
    DELIVERED: { value: 'DELIVERED', text: 'Entregada' },
    CANCELLED: { value: 'CANCELLED', text: 'Cancelada' },
    CANCELLED_NOT_PAYED: { value: 'CANCELLED_NOT_PAYED', text: 'Cancelada no pagada' },
  },
  HOLIDAY: '2021-11-01',
  TUESDAY: '2021-11-02',
  SIX: '2021-11-06',
  SEVEN: '2021-11-07',
  EIGHT: '2021-11-08',
  EVENT_TRANSACTIONS: [
    {
      id: "DISPATCH_CREATED",
      value: "Creación de la nota de venta"
    },
    {
      id: "ORDER_PAYED",
      value: "Pago de la nota de venta"
    },
    {
      id: "PENDING_DISPATCH",
      value: "Pendiente de despacho"
    },
    {
      id: "PENDING_CUSTOMER_DISPATCH",
      value: "Pendiente de despacho cliente"
    }
  ]
};
